export enum PKImportResultType {
    NoChanges = 0,
    Created = 1,
    Updated = 2,
    Reactivated = 3,
    NoMatchingUnit = 100,
    NoMatchingRole = 101,
    UnitIsNotActive = 102,
    MultipleEmailsInPK = 103,
    NoEmailInPK = 104,
    NoUniqueEmailAddressInPK = 105,
    UserNotFoundInPK = 106,
    NoMatchingRoleUnit = 107,
    NoPhoneNumberInPK = 108,
    MultiplePhoneNumbersInPK = 109,
    NoUniquePhoneNumberInPK = 110,
    RolesExcludedFromImport = 111,
    UnknownError = 200,
}
